import ResourcePage from "@/components/ResourcePage";

const STATUS = [
  { value: "new", label: "Neu" },
  { value: "contacted", label: "Kontaktiert" },
  { value: "qualified", label: "Qualifiziert" },
  { value: "won", label: "Gewonnen" },
  { value: "lost", label: "Verloren" },
];

export default function LeadsPage() {
  return (
    <ResourcePage
      resource="leads"
      title="Leads"
      subtitle="Neue Interessenten und potenzielle Kunden."
      singular="Lead"
      newButtonLabel="Lead anlegen"
      createDialogTitle="Lead anlegen"
      editDialogTitle="Lead bearbeiten"
      submitButtonLabel="Lead speichern"
      emptyDescription="Lege deinen ersten Lead an."
      emptyCreateButtonLabel="Lead anlegen"
      testidPrefix="leads"
      defaultValues={{ status: "new" }}
      fields={[
        { name: "title", label: "Titel", type: "text", required: true },
        { name: "company_name", label: "Firmenname", type: "text" },
        { name: "contact_name", label: "Ansprechpartner", type: "text" },
        { name: "email", label: "E-Mail", type: "email" },
        { name: "phone", label: "Telefon", type: "tel" },
        { name: "status", label: "Status", type: "select", options: STATUS },
        { name: "value", label: "Wert (€)", type: "number", step: "0.01" },
        { name: "source", label: "Quelle", type: "text", placeholder: "z. B. Empfehlung, Web" },
        {
          name: "assigned_to",
          label: "Zugewiesen an",
          type: "select",
          optionsFromResource: "users",
        },
        { name: "notes", label: "Notizen", type: "textarea", fullWidth: true },
      ]}
      columns={[
        { key: "title", label: "Lead", render: (r) => <span className="font-medium text-gray-900">{r.title}</span> },
        { key: "company_name", label: "Firma" },
        { key: "contact_name", label: "Ansprechpartner" },
        { key: "status", label: "Status", badge: true },
        {
          key: "value",
          label: "Wert",
          render: (r) =>
            r.value
              ? new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(r.value))
              : <span className="text-gray-400">—</span>,
        },
      ]}
    />
  );
}
